import React, { useMemo } from 'react';

import ArticleList, {
  type ArticleListItem,
} from '../components/ArticleList';
import { useGuide } from '../hooks/useGuide';
import { strings } from '../strings';
import { usePageMeta } from '../utils/pageMeta';

const GuidesScreen = () => {
  const { guide, isLoading, error } = useGuide();
  usePageMeta(strings.pageMeta.guides);

  const items = useMemo<ArticleListItem[]>(
    () =>
      guide.map(article => ({
        key: `${article.title}-${article.url}`,
        title: article.title,
        caption: article.author,
        url: article.url,
      })),
    [guide],
  );

  return (
    <ArticleList
      title={strings.guidesLabel}
      items={items}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default GuidesScreen;
